import Template from '../../component/Template.js';
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';

export default function TeacherCourseMapping() {

    const [admissionYears, setAdmissionYears] = useState([]);
    const [admissionYear, setAdmissionYear] = useState(null);
    const [activeSemester, setActiveSemesterId] = useState(null);
    const [disciplinedata, setDisciplineData] = useState([]);
    const [issaved, setissaved] = useState(false);
    const [semester_id, setSemester] = useState([]);

    const [tableData, setTableData] = useState([]);
    const [isolist, setIsolist] = useState([]);
    const [iso, setISO] = useState(false);
    const [isofilter, setISOfilter] = useState(false);
    const [isoFilterValue, setIsoFilterValue] = useState(null); // ✅ controlled value for supervisor Select
    const [ShowModal, setShowModal] = useState(false);
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [mappedStudents, setMappedStudents] = useState([]);
    const [disciplineId, setDisciplineChange] = useState(null);
    const [disciplinetype, setDisciplineTypeChange] = useState(null);
    const [disciplineName, setDisciplineNameChange] = useState(null);
    const [getStudentMapCount, setStudentMapCount] = useState([]);
    const tableRef = useRef(null);

    const { http } = Api();
    const navigate = useNavigate();

    const isAuth = useAuth();

    if (isAuth === false) {
        navigate("/ino/");
    }

    let cid = localStorage.getItem("collegeid");

    useEffect(() => {
        const fetchActiveEvents = async () => {
            if (admissionYear?.value && semester_id?.value) {
                try {
                    const response = await http.get('getActiveEvents', {
                        params: { event_id: 34 }
                    });
                    console.log("response", response);
                    const matchedEvent = response.data.find(event =>
                        event.admission_year === admissionYear.value &&
                        event.semester_id === semester_id.value &&
                        event.status === "active"
                    );

                    if (matchedEvent) {
                        setActiveSemesterId(matchedEvent.semester_id);
                    } else {
                        setActiveSemesterId(null);
                    }
                } catch (error) {
                    setActiveSemesterId(null);
                }
            } else {
                setActiveSemesterId(null);
            }
        };

        fetchActiveEvents();
    }, [admissionYear, semester_id]);

    useEffect(() => {
        const fetchAdmissionYears = async () => {
            try {
                const response = await http.get('/College/getSFASideActiveAdmissionYear');
                const years = response.data
                    .filter(year => year.admission_year !== 2025)
                    .map((year) => ({
                        id: year.id,
                        value: year.admission_year,
                        label: year.admission_year
                    }));

                setAdmissionYears(years);
            } catch (error) {
                setAdmissionYears([]);
                toast.error("Error fetching admission years");
            }
        };
        fetchAdmissionYears();
    }, []);

    const handleAdmissionYearChange = (selectedOption) => {
        setAdmissionYear(selectedOption);
        setDisciplineChange([]);
        setDisciplineTypeChange(null);
        setDisciplineNameChange(null);
    };

    const handleSemesterChange = (selectedOption) => {
        setSemester(selectedOption);
        setDisciplineChange([]);
        setDisciplineTypeChange(null);
        setDisciplineNameChange(null);
    };

    const handleDisciplineChange = (selectedOption) => {
        setDisciplineChange(selectedOption.did);
        setDisciplineNameChange(selectedOption.value);
        setDisciplineTypeChange(selectedOption.type);
        setISOfilter(false);        // ✅ reset supervisor filter on discipline change
        setIsoFilterValue(null);    // ✅ reset supervisor Select UI on discipline change
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await http.get(`/College/getCollegeDisciplinesforINO`, {
                    params: {
                        college_id: cid,
                        semester_id: semester_id.value,
                        admission_year: admissionYear.value,
                    }
                });

                if (!(response?.data?.status_code === 'ERR5')) {
                    setDisciplineData(response.data);
                }
            } catch (error) {
                toast.error("Error fetching disciplines");
            }
        };

        if (admissionYear?.value && semester_id?.value) {
            fetchData();
        }
    }, [admissionYear, semester_id, issaved]);

    // ✅ Fixed: race condition handled with isCurrent flag + instant table clear
    useEffect(() => {
        let isCurrent = true;

        // Clear immediately on discipline change
        setTableData([]);
        setSelectedStudents([]);
        setIsSelectAllChecked(false);

        if (!disciplineId || disciplinedata.length === 0) return;

        const fetchCollegeTeachersList = async () => {
            try {
                const params = {
                    discipline_id: disciplineId,
                    admission_year: admissionYear?.value,
                    coursetype: disciplinetype,
                };

                if (isofilter) {
                    params.fac_id = isofilter;
                }

                const response = await http.get('/College/viewStudentListprincipal', {
                    params: params,
                });

                // Only update state if this effect is still current
                if (isCurrent) {
                    setTableData(response.data.studentlist);
                    setSelectedStudents([]);
                    setMappedStudents(
                        response.data.studentlist.filter(
                            student => student.iso_student === 'mapped'
                        )
                    );
                }
            } catch (error) {
                if (isCurrent) {
                    setTableData([]);
                    setSelectedStudents([]);
                }
            }
        };

        fetchCollegeTeachersList();

        // Cleanup: mark this effect as stale when discipline changes again
        return () => {
            isCurrent = false;
        };

    }, [disciplineId, disciplinetype, issaved, isofilter]);

    useEffect(() => {
        const fetchCollegeTeachersList = async () => {
            try {
                const response = await http.get('/College/ListIso', {
                    params: {
                        discipline_id: disciplineId,
                        admission_year: admissionYear?.value,
                        coursetype: disciplinetype,
                    },
                });
                setIsolist(response.data.data);
            } catch (error) {
                setIsolist([]);
            }
        };

        fetchCollegeTeachersList();
    }, [disciplineId, issaved]);

    useEffect(() => {
        const StudentCourseMapCount = async () => {
            if (disciplineId.length === 0 || disciplineId.length === null) {
                toast.warning("Please select discipline too");
                return;
            }

            try {
                const response = await http.get('/College/StudentCourseMapCount', {
                    params: {
                        discipline_id: disciplineId,
                        admission_year: admissionYear?.value,
                        discipline_type: disciplinetype,
                        semester: semester_id.value
                    },
                });

                setStudentMapCount(response.data);
            } catch (error) {
                setIsolist([]);
                if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
                    toast.error(error.response.data.message);
                } else {
                    console.error('Error fetching statistics:', error);
                    toast.error('Error fetching statistics');
                }
            }
        };

        if (disciplineId && admissionYear?.value && semester_id?.value) {
            StudentCourseMapCount();
        }
    }, [disciplineId, admissionYear?.value, semester_id?.value, issaved]);

    const handlefirstsubmit = () => {
        setShowModal(true);
    };

    // ✅ Fixed: resets both filter value and Select UI
    const handleISOChangeapi = (e) => {
        if (!e) {
            setISOfilter(false);
            setIsoFilterValue(null);
            return;
        }
        setISOfilter(e.value);
        setIsoFilterValue(e);
    };

    const handleISOChange = (e) => {
        setISO(e.value);
    };

    const handleSubmitData = (e) => {
        e.preventDefault();
        const saveUserDataForSeat = () => {
            http.post('/College/StudentListprincipalapprove', {
                action: 'principal_approved',
                students: selectedStudents
            }).then((response) => {
                if (response.data.status_code === 'MSG1') {
                    setissaved(!issaved);
                    setShowModal(false);
                    setSelectedStudents([]);
                    setIsSelectAllChecked(!isSelectAllChecked);
                    toast.success('Students approved successfully');
                } else {
                    toast.error('Failed to approve students');
                    setissaved(!issaved);
                }
            }).catch((error) => {
                toast.error("Something went wrong");
            });
        };

        saveUserDataForSeat();
    };

    const handleRemoveStudent = (accountid, fac_uid, mic_id) => {
        const RemoveStudent = () => {
            http.post('/College/StudentListprincipalrevert', {
                account_id: accountid,
                mic_id: mic_id,
                fac_uid: fac_uid,
                action: 'principal_reverted'
            }).then((response) => {
                if (response.data.status_code === 'MSG1') {
                    setissaved(!issaved);
                    setShowModal(false);
                    setSelectedStudents([]);
                    setIsSelectAllChecked(!isSelectAllChecked);
                    toast.success('Reverted successfully');
                } else {
                    toast.error('Mapping not found or already deleted');
                    setissaved(!issaved);
                }
            }).catch((error) => {
                toast.error("Mapping not found or already deleted");
            });
        };

        RemoveStudent();
    };

    const handleCancel = () => {
        setShowModal(false);
    };

    const handleGeneratePDFNew = async () => {
        try {
            const response = await http.get('/College/viewStudentListprincipalpdf', {
                params: {
                    college_id: cid,
                    admission_year: admissionYear.value,
                    semester_id: semester_id.value,
                    discipline_id: disciplineId,
                    coursetype: disciplinetype,
                },
                responseType: 'blob',
            });

            if (response && response.data) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    `${localStorage.getItem('username')}_StudentInternshipApproval.pdf`
                );
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                toast.success('PDF generated successfully');
            }
        } catch (error) {
            toast.error('Error generating PDF');
        }
    };

    const handleCheckboxChange = (mic_id) => {
        if (selectedStudents.includes(mic_id)) {
            const student = selectedStudents.filter(id => id !== mic_id);
            setSelectedStudents(student);
            if (student.length === 0) {
                setIsSelectAllChecked(false);
            }
        } else {
            setSelectedStudents([...selectedStudents, mic_id]);
        }
    };

    const handleSelectAll = () => {
        const allSelected = !isSelectAllChecked;
        setIsSelectAllChecked(allSelected);

        if (allSelected) {
            const allStudentIds = tableData
                .filter((studentDetails) => studentDetails?.intership_courses_entry_status === 'ino_forwarded')
                .map((studentDetails) => studentDetails?.mic_id);
            setSelectedStudents(allStudentIds);
        } else {
            setSelectedStudents([]);
        }
    };

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: '200px',
            overflowY: 'auto',
            textAlign: 'left',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '180px',
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            scrollbarColor: '#888 #f1f1f1',
            textAlign: 'left',
        }),
        multiValue: (provided) => ({
            ...provided,
            '&::-webkit-scrollbar': {
                width: '8px',
                textAlign: 'left',
            },
            '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
            },
        }),
    };

    return (
        <>
            <ToastContainer />
            <Template>
                <div className="container-fluid">
                    <div className="row">
                        <div className="table-responsive">
                            <div className="card">
                                <div className="col-md-12">
                                    <div className="card-header">
                                        <div className="py-3 d-flex justify-content-between align-items-center">
                                            <h5>Student Internship Approval</h5>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <div className="card-body">
                                                <div className="row justify-content-center">
                                                    <div className="col-md-12 mb-4">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <label>Admission Year <span className="errorclr">*</span></label>
                                                                <Select
                                                                    maxMenuHeight={200}
                                                                    menuPlacement="auto"
                                                                    id="admyear"
                                                                    name="admyear"
                                                                    className="form"
                                                                    styles={customStyles}
                                                                    options={admissionYears}
                                                                    value={admissionYear}
                                                                    onChange={handleAdmissionYearChange}
                                                                />
                                                            </div>

                                                            <div className="col-md-4">
                                                                <label>Semester <span className="errorclr">*</span></label>
                                                                <Select
                                                                    maxMenuHeight={200}
                                                                    menuPlacement="auto"
                                                                    id="semester_id"
                                                                    name="semester_id"
                                                                    className="form"
                                                                    styles={customStyles}
                                                                    options={[
                                                                        { value: 4, label: '4' },
                                                                    ]}
                                                                    value={semester_id}
                                                                    onChange={handleSemesterChange}
                                                                />
                                                            </div>

                                                            <div className="col-md-4">
                                                                <label>Discipline <span className="errorclr">*</span></label>
                                                                <Select
                                                                    maxMenuHeight={200}
                                                                    menuPlacement="auto"
                                                                    id="discipline_id"
                                                                    name="discipline_id"
                                                                    className="form"
                                                                    styles={customStyles}
                                                                    onChange={handleDisciplineChange}
                                                                    options={disciplinedata.length === 0
                                                                        ? [{ value: '0', label: 'No data found' }]
                                                                        : disciplinedata
                                                                            .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                                                            .map(disciplines => ({
                                                                                did: disciplines.discipline_id,
                                                                                value: disciplines.discipline_name,
                                                                                label: disciplines.discipline_name,
                                                                                type: disciplines.college_course_type
                                                                            }))
                                                                    }
                                                                    value={
                                                                        disciplinedata
                                                                            .map(d => ({
                                                                                did: d.discipline_id,
                                                                                value: d.discipline_name,
                                                                                label: d.discipline_name,
                                                                                type: d.college_course_type
                                                                            }))
                                                                            .find(option => option.value == disciplineName) || null
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="table-responsive ovrflw" style={{ overflowX: 'auto' }}>
                                                    <div className="row justify-content-center">
                                                        <div className="col-md-11 stat-out-bod">
                                                            <table
                                                                className="table-striped table-bordered ex-table mb-10"
                                                                ref={tableRef}
                                                                id="dataTableBos"
                                                                width="100%"
                                                                style={{ textAlign: 'center', tableLayout: 'fixed' }}
                                                            >
                                                                <thead>
                                                                    <tr className="col-cnt-tab-bg-clr" style={{ height: '40px' }}>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                                                            Total Students
                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                                                            Students Mapped to Supervisors
                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                                                            Students With Topic Selection
                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                                                            Reverted To Student
                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                                                            Pending with Internship Supervisor
                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                                                            Pending with INO
                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                                                            Pending at Principal
                                                                        </th>
                                                                        <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                                                            Principal Approved Topic Selections
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>{getStudentMapCount?.student_internship_count ? getStudentMapCount.student_internship_count : '0'}</td>
                                                                        <td>{getStudentMapCount?.iso_student_count ? getStudentMapCount.iso_student_count : '0'}</td>
                                                                        <td>{getStudentMapCount?.entered_count ? getStudentMapCount.entered_count : '0'}</td>
                                                                        <td>{getStudentMapCount?.iso_reverted_count ? getStudentMapCount.iso_reverted_count : '0'}</td>
                                                                        <td>{getStudentMapCount?.entered_count ? getStudentMapCount.entered_count : '0'}</td>
                                                                        <td>{getStudentMapCount?.iso_forwarded_count ? getStudentMapCount.iso_forwarded_count : '0'}</td>
                                                                        <td>{getStudentMapCount?.ino_forwarded_count ? getStudentMapCount.ino_forwarded_count : '0'}</td>
                                                                        <td>{getStudentMapCount?.principal_approved_count ? getStudentMapCount.principal_approved_count : '0'}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="pgm-map-box mb-4" style={{ zIndex: '1200' }}>

                                                    <div className="row mt-2 align-items-end">
                                                        {/* LEFT SIDE BUTTON */}
                                                        <div className="col-md-8 d-flex align-items-center gap-3">
                                                            {selectedStudents.length > 0 && (
                                                                <button
                                                                    className="btn btn-success"
                                                                    type="button"
                                                                    onClick={handlefirstsubmit}
                                                                >
                                                                    Approve Selected Students
                                                                </button>
                                                            )}

                                                            {/* ✅ Only show PDF button when there is data */}
                                                            {Array.isArray(tableData) && tableData.length > 0 && (
                                                                <button
                                                                    className="lbl2 btn btn-primary"
                                                                    onClick={() => handleGeneratePDFNew()}
                                                                    title="Download"
                                                                >
                                                                    <i className="bi bi-arrow-down-square"></i>
                                                                </button>
                                                            )}
                                                        </div>

                                                        {/* RIGHT SIDE FILTER */}
                                                        <div className="col-md-4 text-end">
                                                            <Select
                                                                maxMenuHeight={200}
                                                                menuPlacement="auto"
                                                                className="form"
                                                                styles={customStyles}
                                                                placeholder="Filter Supervisor..."
                                                                isClearable
                                                                value={isoFilterValue}  // ✅ controlled so it resets on discipline change
                                                                onChange={(e) => handleISOChangeapi(e)}
                                                                options={
                                                                    isolist.length === 0
                                                                        ? [{ value: '0', label: 'No data found' }]
                                                                        : isolist
                                                                            .sort((a, b) => a.fac_name.localeCompare(b.fac_name))
                                                                            .map(item => ({
                                                                                value: item.fac_pk,
                                                                                label: item.fac_name,
                                                                            }))
                                                                }
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="table-container mt-1">
                                                        <table className="display dataTable table-striped table-bordered ex-v-table" id="dataTable">
                                                            <thead>
                                                                <tr className="bg-primary">
                                                                    <th scope="col" width="8%">
                                                                        {Array.isArray(tableData) &&
                                                                            tableData.length > 0 &&
                                                                            tableData.some(
                                                                                row => row.intership_courses_entry_status?.trim() === 'ino_forwarded'
                                                                            ) && (
                                                                                <input
                                                                                    id="select-all"
                                                                                    type="checkbox"
                                                                                    checked={isSelectAllChecked}
                                                                                    onChange={handleSelectAll}
                                                                                />
                                                                            )}
                                                                    </th>
                                                                    <th scope="col">Sl NO</th>
                                                                    <th scope="col">PRN & Name</th>
                                                                    <th scope="col">Course</th>
                                                                    <th scope="col">Internship Topic & Mode</th>
                                                                    <th scope="col">Current Status</th>
                                                                    <th scope="col">Supervisor ID & Name</th>
                                                                    <th scope="col">IPO Name</th>
                                                                    <th scope="col">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {Array.isArray(tableData) && tableData.length > 0 ? (
                                                                    tableData.map((row, index) => (
                                                                        <tr key={row.mic_id}>
                                                                            <td className="text-center">
                                                                                {row.intership_courses_entry_status?.trim() === 'ino_forwarded' && (
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={selectedStudents.includes(row.mic_id)}
                                                                                        onChange={() => handleCheckboxChange(row.mic_id)}
                                                                                    />
                                                                                )}
                                                                            </td>
                                                                            <td>{index + 1}</td>
                                                                            <td>
                                                                                <strong>{row.PRN}</strong>
                                                                                <br />
                                                                                {row.studentname}
                                                                            </td>
                                                                            <td>{row.course ? row.course : "N/A"}</td>
                                                                            <td>
                                                                                {row.internship_topic ? row.internship_topic : "Not assigned"}<br />
                                                                                <b>Mode:</b>{row.mode_of_study ? row.mode_of_study : "N/A"}
                                                                            </td>
                                                                            <td className="text-center">
                                                                                {row.intership_courses_entry_status === 'iso_forwarded' && (
                                                                                    <span className="badge bg-info text-dark rounded-pill">
                                                                                        ISO Forwarded
                                                                                    </span>
                                                                                )}
                                                                                {row.intership_courses_entry_status === 'ino_forwarded' && (
                                                                                    <span className="badge bg-info text-dark rounded-pill">
                                                                                        INO Forwarded
                                                                                    </span>
                                                                                )}
                                                                                {row.intership_courses_entry_status === 'principal_approved' && (
                                                                                    <span className="badge bg-success rounded-pill">
                                                                                        Principal Approved
                                                                                    </span>
                                                                                )}
                                                                                {row.intership_courses_entry_status === 'principal_reverted' && (
                                                                                    <span className="badge bg-danger rounded-pill">
                                                                                        Principal Reverted
                                                                                    </span>
                                                                                )}
                                                                                {!row.intership_courses_entry_status && 'N/A'}
                                                                            </td>
                                                                            <td>{row.fac_uid}<br />{row.faculty_name}</td>
                                                                            <td>
                                                                                {(() => {
                                                                                    if (row.type === 'external' && row.external_ipo_name) {
                                                                                        return row.external_ipo_name;
                                                                                    }
                                                                                    if (row.type === 'internal' && row.vendor_name) {
                                                                                        return row.vendor_name;
                                                                                    }
                                                                                    return 'N/A';
                                                                                })()}
                                                                                <br /><br />
                                                                                <span className={`fw-bold ${row.type === 'internal'
                                                                                    ? 'text-success'
                                                                                    : row.type === 'external'
                                                                                        ? 'text-primary'
                                                                                        : 'text-muted'
                                                                                    }`}>
                                                                                    {row.type ? row.type.charAt(0).toUpperCase() + row.type.slice(1) : ''}
                                                                                </span>
                                                                            </td>
                                                                            <td className="text-center">
                                                                                {row.intership_courses_entry_status?.trim().toLowerCase() === 'ino_forwarded' ? (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-outline-warning btn-sm rounded-pill px-3"
                                                                                        onClick={() =>
                                                                                            handleRemoveStudent(row.accountid, row.fac_uid, row.mic_id)
                                                                                        }
                                                                                        title="Revert Student"
                                                                                    >
                                                                                        <i className="fa fa-undo me-1" />
                                                                                        Revert
                                                                                    </button>
                                                                                ) : '-'}
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="9" className="text-center">
                                                                            No data available
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    <div className={`modal fade show ${ShowModal ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-modal="true">
                                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                                            <div className="modal-content">
                                                                <div className="modal-body">
                                                                    <div className="modal-toggle-wrapper">
                                                                        <h4 className="text-center pb-2">Are you sure you want to approve these students?</h4>
                                                                        <div className="text-center">
                                                                            <p className="txt-aln-jst">Please note that this action cannot be undone.</p>
                                                                        </div>
                                                                        <div className="d-flex justify-content-center mt-3">
                                                                            <div>
                                                                                <button className="btn btn-danger mx-2" onClick={handleSubmitData}>Save</button>
                                                                                <button
                                                                                    className="btn"
                                                                                    style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                                                                    data-bs-dismiss="modal"
                                                                                    onClick={handleCancel}
                                                                                >
                                                                                    Cancel
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Template>
        </>
    );
}